import gql from 'graphql-tag';
import qs from 'qs';
// QUERY
export const isMultiFilterListActive = (parent) => {
    return (searchParams) => {
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        // e.g. Armchair:product-type:151
        const [, name, category] = parent.id.split(':');
        // Get the list filters from the search params
        // e.g.
        // {
        //// "151:product-type": ["Armchair"]
        // }
        const paramFilter = qs.parse(query, {
            ignoreQueryPrefix: true
        }).multiList;
        if (!paramFilter)
            return false;
        // Key contains category on category pages, but not on search results
        const key = category ? `${category}:${name}` : name;
        if (!paramFilter[key])
            return false;
        const listFilterItemValues = parent.items.map((item) => item.value);
        return paramFilter[key].reduce((prev, filterFromParams) => {
            if (prev)
                return prev;
            return listFilterItemValues.includes(filterFromParams);
        }, false);
    };
};
////////////////////////////////////////////////////////////////////////////////
// MUTATION
export const clearMultiListFilterList = (_, { listIndex, filter }, { client }) => {
    // We can let toggleMultiListFilterItem handle this by passing a null value
    const result = client.mutate({
        mutation: gql `
      mutation toggleMultiListItem {
        toggleMultiListFilterItem(
          value: $value
          filter: $filter
          listIndex: $listIndex
        ) @client {
          isActive @client
        }
      }
    `,
        variables: {
            value: null,
            filter,
            listIndex
        }
    });
    return result;
};
//# sourceMappingURL=multiListFilterList.js.map